import React, { forwardRef } from 'react';
import styled, { css, useTheme } from 'styled-components';
import * as icons from '@boxine/tonies-ui/icons';
import { useTranslation } from 'react-i18next';
import Icon from '../Icon';
import { BounceBox } from './BounceBox';
const StyledButton = styled.button `
  background-color: transparent;
  border: none;
  cursor: pointer;
  grid-template-areas: 'button';
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;

  @supports not (selector(:focus-visible)) {
    outline: 0;
    &.focus-visible,
    &:focus {
      svg:first-of-type {
        box-shadow: 0 0 0.2rem 0.2rem white, 0 0 0.2rem 0.25rem #4d90ff;
        border-radius: 50%;
      }
    }
  }

  @supports selector(:focus-visible) {
    outline: 0;
    &:focus-visible {
      svg:first-of-type {
        box-shadow: 0 0 0.2rem 0.2rem white, 0 0 0.2rem 0.25rem #4d90ff;
        border-radius: 50%;
      }
    }
  }
`;
// fix button grid fix in safari 13
const Wrapper = styled.span `
  align-items: center;
  display: grid;
  justify-items: center;
  width: 100%;
  height: 100%;
`;
const ProgressIndicator = styled.svg `
  grid-area: button;
  height: 100%;
  width: 100%;
`;
const StyledIcon = styled(Icon) `
  grid-area: button;
  height: 70%;
  width: 70%;
  transform: translateZ(0);

  &:hover {
    path {
      transition: fill 0.4s linear;
    }

    ${({ theme, styling }) => css `
      ${styling === 'primary'
    ? css `
            path:first-of-type {
              fill: ${theme.colors['primary-hover']};
            }
          `
    : styling === 'secondary'
        ? css `
            /* only fill icon */
            path:nth-child(3) {
              fill: ${theme.colors['primary-hover']};
            }
          `
        : null}
    `}
  }
`;
const InnerMediaPlayerButton = ({ children = null, className = undefined, progress = undefined, onClick, isBoxed = false, styling: stylingProp = undefined, 'data-trackingid': dataTrackingId, }, ref) => {
    const { colors, colorContext } = useTheme();
    const styling = stylingProp || (!isBoxed && colorContext === 'dark')
        ? 'secondary'
        : 'primary';
    const isMediaPlaying = typeof progress === 'number';
    let component = (React.createElement(StyledButton, { className: className, "data-testid": "audio-sample-button-pause", onClick: onClick, ref: ref, "data-trackingid": dataTrackingId, "aria-pressed": isMediaPlaying, "aria-label": useTranslation().t('AudioSample:copy') },
        React.createElement(Wrapper, null,
            React.createElement(ProgressIndicator, { viewBox: "0 0 36 36" },
                React.createElement("path", { d: "M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831", fill: "none", stroke: colors.lightgrey, strokeWidth: 3 }),
                isMediaPlaying && (React.createElement("path", { 
                    // prevent `progress` from being undefined here because it would result in a layout bug with the progress indicator being at 100% for a second
                    strokeDasharray: `${!progress ? 0.1 : progress}, 100`, d: "M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831", fill: "none", stroke: colors.primary, strokeLinecap: "round", strokeWidth: 3 }))),
            React.createElement(StyledIcon, { type: isMediaPlaying ? icons.stopFilled2 : icons.playFilled2, fill: styling === 'secondary' ? '#fff' : colors.primary, fillAll: styling === 'secondary' ? colors.darkergrey : '#fff', styling: styling }),
            children)));
    if (isBoxed) {
        component = React.createElement(BounceBox, null, component);
    }
    return component;
};
export const MediaPlayerButton = forwardRef(InnerMediaPlayerButton);
MediaPlayerButton.displayName = 'MediaPlayerButton';
